const START_DATE_KEY = "start_date";
const END_DATE_KEY = "end_date";
const RESERVATION_ID_KEY = "reservation_id";

const SEARCH_TYPE_KEY = "search_type";
const CHECK_IN_VALUE = "check_in";
const CHECK_OUT_VALUE = "check_out";
const STAY_DATE_VALUE = "stay_date";
const UPDATED_DATE_VALUE = "updated_date";
const RESERVATION_ID_VALUE = "reservation_id";

const RESERVATION_SEARCH_TYPE_VALUES = [
	CHECK_IN_VALUE,
	CHECK_OUT_VALUE,
	STAY_DATE_VALUE,
	UPDATED_DATE_VALUE,
	RESERVATION_ID_VALUE,
] as const;

export type ManagementReservationSearchTypeForQueryParams = (typeof RESERVATION_SEARCH_TYPE_VALUES)[number];

export const isManagementReservationSearchType = (
	value: string | null,
): value is ManagementReservationSearchTypeForQueryParams =>
	RESERVATION_SEARCH_TYPE_VALUES.includes(value as ManagementReservationSearchTypeForQueryParams);

export const RESERVATION = {
	DATE_RANGE: {
		START_DATE: {
			KEY: START_DATE_KEY,
		},
		END_DATE: {
			KEY: END_DATE_KEY,
		},
	},
	RESERVATION_ID: {
		KEY: RESERVATION_ID_KEY,
	},
	SEARCH_TYPE: {
		KEY: SEARCH_TYPE_KEY,
		VALUE: {
			CHECK_IN: CHECK_IN_VALUE as ManagementReservationSearchTypeForQueryParams,
			CHECK_OUT: CHECK_OUT_VALUE as ManagementReservationSearchTypeForQueryParams,
			STAY_DATE: STAY_DATE_VALUE as ManagementReservationSearchTypeForQueryParams,
			UPDATED_DATE: UPDATED_DATE_VALUE as ManagementReservationSearchTypeForQueryParams,
			RESERVATION_ID: RESERVATION_ID_VALUE as ManagementReservationSearchTypeForQueryParams,
		},
	},
};
